/**
 * Formats the user limit copy.
 * @param userLimit - The user limit.
 * @returns The formatted user limit copy.
 */
export const getUsersCopy = (userLimit: number): string => {
  let userLimitCopy
  switch (userLimit) {
    case 0:
      userLimitCopy = 'Limited to 1'
      break
    case 9999:
      userLimitCopy = 'Unlimited'
      break
    default:
      userLimitCopy = `Limited to ${userLimit}`
  }
  return userLimitCopy
}

/**
 * Gets the users copy based on the user limit and current user count.
 * @param userLimit - The user limit.
 * @returns The formatted users copy.
 */
export const getUsersCopyV2 = (
  userLimit: number,
  userCount: number,
): string => {
  let userLimitCopy
  switch (userLimit) {
    case 0:
      userLimitCopy = '1 / 1'
      break
    case 9999:
      userLimitCopy = `${userCount} / Unlimited`
      break
    default:
      userLimitCopy = `Limited to ${userLimit}`
  }
  return userLimitCopy
}
